export default "__VITE_ASSET__9ff7ed49__"